import React, { useEffect, useState } from "react";
import { GraduationCap, LogIn, AlertTriangle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const location = useLocation();
  const [err, setErr] = useState(location.state?.error || null);

  // Clear location.state so the error banner does NOT persist across hard refreshes.
  // React Router keeps state in window.history.state which survives refresh otherwise.
  useEffect(() => {
    if (location.state?.error) {
      try { window.history.replaceState({}, "", location.pathname); } catch {}
    }
  }, [location]);

  const handleLogin = () => {
    setErr(null);
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-stretch">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 text-white"
           style={{ background: "linear-gradient(160deg, #0B192C 0%, #0F2C59 60%, #1D4ED8 130%)" }}>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center">
            <GraduationCap className="w-6 h-6" />
          </div>
          <span className="heading-font text-2xl font-bold">Admissio<span className="text-orange-400">.</span></span>
        </div>
        <div className="space-y-6">
          <h1 className="heading-font text-4xl xl:text-5xl font-bold leading-tight">
            The admissions <br/> command center.
          </h1>
          <p className="text-slate-300 max-w-md">
            One system for your entire pipeline — partner-led B2B applications and direct B2C students —
            from documents through admissions, filing, enrollment, and commission payouts.
          </p>
          <div className="grid grid-cols-3 gap-4 pt-6 border-t border-white/10">
            {[["Partners","managed"],["Applications","tracked"],["Commissions","paid"]].map(([a,b])=> (
              <div key={a}>
                <div className="heading-font text-xl font-semibold">{a}</div>
                <div className="text-xs text-slate-400">{b}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-xs text-slate-400">© 2026 Admissio Internal Tools</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="mb-8 lg:hidden flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center text-white">
              <GraduationCap className="w-6 h-6" />
            </div>
            <span className="heading-font text-2xl font-bold text-slate-900">Admissio</span>
          </div>
          <h2 className="heading-font text-3xl font-bold text-slate-900">Sign in</h2>
          <p className="text-slate-500 mt-2 text-sm">
            Employee access only. Your Google email must be added by an admin first.
          </p>
          {err && (
            <div data-testid="login-error" className="mt-6 flex items-start gap-2 p-3 rounded-lg border border-red-200 bg-red-50 text-red-800 text-sm">
              <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{err}</span>
            </div>
          )}
          <div className="mt-8 space-y-4">
            <Button
              data-testid="google-signin-button"
              onClick={handleLogin}
              size="lg"
              className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white flex items-center gap-3">
              <LogIn className="w-5 h-5" />
              Continue with Google
            </Button>
            <div className="text-xs text-slate-400 text-center pt-4">
              Protected by Emergent Auth · Sessions expire after 7 days
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
